export const calculateFontSize = (width, depth, text) => {
    const baseSize = width * 0.5;
    const textLength = text.length;
    const scaleFactor = Math.min(1, 5 / textLength);
    return baseSize * 0.2 / 2;
};


export const createRectanglePoints = (width, height) => {
    const halfWidth = width / 2;
    const halfHeight = height / 2;
    return [
        [-halfWidth, -halfHeight, 0],
        [halfWidth, -halfHeight, 0],
        [halfWidth, halfHeight, 0],
        [-halfWidth, halfHeight, 0],
        [-halfWidth, -halfHeight, 0]
    ];
};

export const getWallHeight = (element) => {
    const MIN_HEIGHT = 200;
    const MAX_HEIGHT = 50000;
    if (!element) return MIN_HEIGHT; // Default height if element is undefined

    let height = element.height || MIN_HEIGHT;

    // If height is provided (non-zero), cap it to MAX
    if (element.height) {
        height = Math.min(height, MAX_HEIGHT);
    }

    return height;
};